<script setup lang="ts">
// No props or logic needed
</script>

<template>
<div
  class="page-loading-state"
  v-loading="true"
  element-loading-background="rgba(0, 0, 0, 0.5)"
></div>
</template>
<style lang="scss" scoped>
.page-loading-state {
  @apply fixed z-9999 inset-0 flex justify-center items-center bg-transparent;

  transition: background-color 0.2s;

  :deep(svg) {
    @apply w-16 h-16;

    circle {
      stroke-width: 4px;
    }
  }
}
</style>
